<div>
  <app-titlebar #titlebar></app-titlebar>
</div>
<mdq-settings [apiBaseUrl]="backendUrl" [apiToken]="mdQueryToken()" />

